export const STREAM_LIVE_RECEIVED = '@ZAPI_STREAM_LIVE_RECEIVED';
export const STREAM_RECORDING_RECEIVED = '@ZAPI_STREAM_RECORDING_RECEIVED';
export const STREAM_REPLAY_RECEIVED = '@ZAPI_STREAM_REPLAY_RECEIVED';
export const STREAM_AVOD_RECEIVED = '@ZAPI_STREAM_AVOD_RECEIVED';
export const STREAM_TIMESHIFT_REGISTERED = '@ZAPI_STREAM_TIMESHIFT_REGISTERED';
export const STREAM_TIMESHIFT_RECEIVED = '@ZAPI_STREAM_TIMESHIFT_RECEIVED';
export const STREAM_VOD_RECEIVED = '@ZAPI_STREAM_VOD_RECEIVED';
export const STREAM_VOD_TRAILER_RECEIVED = '@ZAPI_STREAM_VOD_TRAILER_RECEIVED';
